export const PERIODO_TODO_ID = 0;
export const PERIODO_HOY_ID = 1;
export const PERIODO_AYER_ID = 2;
export const PERIODO_ULTIMOS_SIETE_DIAS_ID = 3;
export const PERIODO_ULTIMOS_CATORCE_DIAS_ID = 4;
export const PERIODO_ULTIMOS_TREINTA_DIAS_ID = 5;
export const PERIODO_MES_ACTUAL_ID = 6;
export const PERIODO_MES_PASADO_ID = 7;
export const PERIODO_ESTE_ANIO_ID = 8;
export const PERIODO_ANIO_PASADO_ID = 9;
export const PERIODO_PERSONALIZADO_ID = 12;